<template>
    <b-container>
        <b-tabs align="center">
            <b-tab :title="$globalStore.translate('settings.file.extensions')">
                <b-card>
                    <b-card-body>
                        <b-form-textarea
                            id="textarea"
                            v-model="allowedFileExtensions"
                            rows="4"
                            max-rows="8"
                        ></b-form-textarea>
                        <br>
                        <b-button variant="primary" class="float-right" @click="saveAllowedFileExtensions">Speichern</b-button>
                        <b-button variant="danger" class="float-right" @click="resetAllowedFileExtensions">Standard wiederherstellen</b-button>
                    </b-card-body>
                </b-card>
            </b-tab>
            <b-tab :title="$globalStore.translate('settings.email.templates')">
                <b-card>
                    <b-card-header>
                        <b>Sprache</b>
                    </b-card-header>

                    <b-card-body>
                        <b-form-group
                            label="Sprache"
                            label-for="inputLanguage"
                        >
                            <b-form-select id="inputLanguage" @change="loadTemplates" v-model="lang">
                                <option value="de">Deutsch</option>
                                <option value="en">Englisch</option>
                            </b-form-select>
                        </b-form-group>
                    </b-card-body>
                </b-card>

                <div v-for="template in templates">
                    <b-card>
                        <b-card-header>
                            <b>{{ template.title }}</b>
                        </b-card-header>

                        <b-card-body>
                            <b-form-textarea :rows="(template.text.match(/\n/g) || '').length + 1" v-model="template.text"></b-form-textarea>

                            <b-button variant="primary" class="float-right" @click="saveTemplate(template.name, template.text)">Speichern</b-button>
                        </b-card-body>
                    </b-card>
                </div>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Settings",
        data() {
            return {
                allowedFileExtensions: '',
                templates: [],
                lang: 'de'
            }
        },
        methods: {
            resetAllowedFileExtensions: function () {
                axios.patch('https://drop.rautec.de/api/options/extensions').then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('Erlaubte Dateiendungen erfolgreich zurückgesetzt.');

                        this.loadExtensions();
                    } else {
                        this.$toastError('Es ist ein Fehler während des speicherns aufgetreten.');
                    }
                }).catch(reason => {
                    this.$toastError('Es ist ein Fehler während des speicherns aufgetreten.');
                });
            },
            saveAllowedFileExtensions: function () {
                let allowedExtension = this.allowedFileExtensions;

                axios.put('https://drop.rautec.de/api/options/extensions', { extensions: allowedExtension }).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('Erfolgreich gespeichert.');
                    } else {
                        this.$toastError('Es ist ein Fehler während des speicherns aufgetreten.');
                    }
                }).catch(reason => {
                    this.$toastError('Es ist ein Fehler während des speicherns aufgetreten.');
                });
            },
            saveTemplate: function (templateName, templateText) {
                axios.put('https://drop.rautec.de/api/templates', { name: templateName, text: templateText, lang: this.lang }).then(response => {
                    if (response.data.success) {
                        this.$toastSuccess('Erfolgreich gespeichert.');
                    } else {
                        this.$toastError('Es ist ein Fehler während des speicherns aufgetreten.');
                    }
                }).catch(reason => {
                    this.$toastError('Es ist ein Fehler während des speicherns aufgetreten.');
                });
            },
            loadExtensions: function () {
                axios.get('https://drop.rautec.de/api/options/extensions').then(response => {
                    if (response.data.extensions) {
                        this.allowedFileExtensions = response.data.extensions.join();
                    }
                });
            },
            loadTemplates: function () {
                axios.get('https://drop.rautec.de/api/templates', { params: { 'lang': this.lang }}).then(response => {
                    if (response.data.templates) {
                        this.templates = response.data.templates;
                    }
                });
            }
        },
        mounted() {
            this.loadExtensions();

            this.loadTemplates();
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings.vue